"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_lottie_player_1 = __importDefault(require("react-lottie-player"));
const lottie_colorify_1 = require("lottie-colorify");
const loaderWhite_json_1 = __importDefault(require("../../assets/gifs/loaderWhite.json"));
const loaderBlue_json_1 = __importDefault(require("../../assets/gifs/loaderBlue.json"));
const master_1 = require("../../constants/master");
const Loader = (props) => {
    return (react_1.default.createElement(react_lottie_player_1.default, { id: "loader", loop: true, animationData: props.type === "primary"
            ? (0, lottie_colorify_1.flatten)((0, master_1.getMasterConfig)().primaryColor, loaderBlue_json_1.default)
            : loaderWhite_json_1.default, play: true, className: props.className ? props.className : "", style: Object.assign({ minWidth: `${props.height}px`, maxWidth: `${props.height}px`, minHeight: `${props.height}px`, maxHeight: `${props.height}px` }, props.styles) }));
};
exports.default = Loader;
